module.exports = {"361003001":"金峰街道","361003100":"孝岗镇","361003101":"小璜镇","361003102":"圩上桥镇","361003103":"马圩镇","361003104":"詹圩镇","361003105":"岗上积镇","361003106":"杨桥殿镇","361003107":"黎圩镇","361003108":"王桥镇","361003200":"珀玕乡","361003201":"邓家乡","361003202":"虎圩乡","361003203":"瑶圩乡","361003400":"红星垦殖场","361003401":"红光垦殖场","361003402":"红亮垦殖场","361003403":"甘坑生态林场","361003406":"东乡县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361003.json
// module id = 1442
// module chunks = 0